import React, { useState } from "react";

import { Link, useLocation } from "react-router-dom";

import ProLayout from "@ant-design/pro-layout";

import LogoImage from "assets/logo.svg";

import useRouteConfig from "./menu";

import Footer from "components/Footer";

import Navbar from "./components/navbar/Navbar";
import useCurrentSiteId from "./hooks/useCurrentSiteId";
import { fetchSiteOverview } from "services/site";
import { connect } from "react-redux";
import { setCurrentSiteInfo } from "store/modules/site";

import RouteMap from "components/route/RouteMap";
import ROUTES from "./routes";
import SystemInfo from "components/SystemInfo";

import "@ant-design/pro-table/dist/table.min.css";
import "@ant-design/pro-layout/dist/layout.min.css";
import "@ant-design/pro-form/dist/form.min.css";
import "@ant-design/pro-card/dist/card.min.css";
import "components/MenuFix.css";

const StationView: React.FC<any> = ({ setCurrentSiteInfo }) => {
  const currentSiteId = useCurrentSiteId();
  const [loading, setLoading] = React.useState(true);
  const location = useLocation();
  const routeConfig = useRouteConfig()
  const [openKeys, setOpenKeys] = useState<string[]>([]);
  
  React.useEffect(() => {
    fetchSiteOverview(currentSiteId)
      .then((data) => {
        setCurrentSiteInfo(data);
      })
      .then(() => {
        setLoading(false);
      });
  }, [currentSiteId, setCurrentSiteInfo]);

  // 根据当前路径自动展开对应的菜单
  React.useEffect(() => {
    const currentPath = location.pathname;
    let keysToOpen: string[] = [];
    
    if (currentPath.includes('/station/')) {
      if (currentPath.includes('/overview') || currentPath.includes('/monitor')) {
        keysToOpen.push('/station/overview');
      } else if (currentPath.includes('/device')) {
        keysToOpen.push('/station/device/list');
      } else if (currentPath.includes('/data')) {
        keysToOpen.push('/station/data/list');
      }
    }
    
    setOpenKeys(keysToOpen);
  }, [location.pathname]);
  return (
    <ProLayout
      loading={loading}
      title="LRMS"
      logo={LogoImage}
      location={location}
      fixSiderbar
      fixedHeader
      route={routeConfig}
      menuItemRender={(item, dom) => {
        // 如果没有路径但有子菜单，保持原有展开/折叠行为
        if (!item.path && item.routes && item.routes.length > 0) {
          return dom;
        }
        // 如果有路径，则包装为链接
        if (item.path) {
          return <Link to={item.path}>{dom}</Link>;
        }
        // 其他情况直接返回dom
        return dom;
      }}
      selectedKeys={[location.pathname]}
      openKeys={openKeys}
      onOpenChange={(keys: string[] | false) => {
        // 根据当前路径智能展开对应的菜单
        const currentPath = location.pathname;
        let newKeys = keys || [];
        
        // 如果当前路径是某个二级菜单项，确保其父菜单展开
        if (currentPath.includes('/station/')) {
          if (currentPath.includes('/overview') || currentPath.includes('/monitor')) {
            newKeys = newKeys.filter(key => key !== '/station/overview');
            if (!newKeys.includes('/station/overview')) {
              newKeys.push('/station/overview');
            }
          } else if (currentPath.includes('/device')) {
            if (!newKeys.includes('/station/device/list')) {
              newKeys.push('/station/device/list');
            }
          } else if (currentPath.includes('/data')) {
            if (!newKeys.includes('/station/data/list')) {
              newKeys.push('/station/data/list');
            }
          }
        }
        
        setOpenKeys(newKeys);
      }}
      links={SystemInfo}
      headerContentRender={() => <Navbar />}
      footerRender={() => <Footer />}
    >
      <RouteMap config={ROUTES} />
    </ProLayout>
  );
};

export default connect(null, { setCurrentSiteInfo })(StationView);
